export interface ItemCategory {
  id?: number;
  name: string;
  description?: string;
  is_active?: boolean;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;
}

export interface ItemCategoryFilters {
  id?: number | null;
  name?: string | '';
  is_active?: boolean | '';
  page: number;
  per_page: number;
  sort: string;
  order: string;
}

export const defaultItemCategoryFilters: ItemCategoryFilters = {
  page: 1,
  per_page: 10,
  sort: 'id',
  order: 'desc'
};
